import React, { useState, useEffect } from "react";
import { withPrefix } from "gatsby";
import underline from "../../../assets/images/icons/menu.svg";
import {
  normalizeTwoWords,
  findTarget,
  findRel,
} from "../../../shared/utils/stringUtilities";

import "./navAccordion.scss";

const NavAccordion = (props: NavAccordionInterface) => {
  const {
    category,
    index,
    setActiveItem,
    activeItem,
    isAnyActive,
    setIsAnyActive,
  } = props;

  const [isActive, toggleActive] = useState(false);

  useEffect(() => {
    index !== activeItem && toggleActive(false);
  }, [activeItem]);

  const url = typeof window !== "undefined" ? window.location.pathname : "";

  const listaMenu = (subcat: any, k: number, slug: string) => (
    <li
      className={`gtmMenuTransSubcategoria${normalizeTwoWords(
        subcat.nombreSubcategoria
      )}`}
      key={`cat${k}`}
    >
      <a
        className={`gtmMenuTransSubcategoria${normalizeTwoWords(
          subcat.nombreSubcategoria
        )}`}
        target={findTarget(slug)}
        rel={findRel(slug)}
        href={slug}
      >
        <span>{subcat.nombreSubcategoria}</span>
        {url === slug && <img src={underline} alt="underline" />}
      </a>
    </li>
  );

  const existCategory =
    category.referenciaSubcategorias &&
    category.referenciaSubcategorias.length > 0;

  return (
    <div className="a-nav-accord">
      {category.referenciaSubcategorias ? (
        <button
          className={`a-nav-accord__btn ${
            isActive ? "a-nav-accord__btn--active" : ""
          } ${
            !isAnyActive && index !== activeItem
              ? "a-nav-accord__btn--locked"
              : ""
          } gtmMenuTransCategoria${normalizeTwoWords(
            category.nombreCategoria
          )}`}
          onClick={() => {
            setActiveItem(index);
            toggleActive(!isActive);
            setIsAnyActive(isActive);
          }}
        >
          <span>{category.nombreCategoria}</span>
          {url === withPrefix(`/${category.slug}`) && (
            <img src={underline} alt="underline" />
          )}
        </button>
      ) : (
        <a
          href={category.slug === "/" ? "/" : withPrefix(`/${category.slug}`)}
          className={`a-nav-accord__link ${
            !isAnyActive && index !== activeItem
              ? "a-nav-accord__link--locked"
              : ""
          } 
            gtmMenuTransCategoria${normalizeTwoWords(
              category.nombreCategoria
            )}`}
          rel={findRel(category.slug)}
        >
          <span>{category.nombreCategoria}</span>
          {url === withPrefix(`/${category.slug}`) && (
            <img src={underline} alt="underline" />
          )}
        </a>
      )}
      <ul
        className={`a-nav-accord__sub ${
          isActive && index === activeItem
            ? "a-nav-accord__sub--active"
            : "a-nav-accord__sub--hidden"
        }`}
      >
        <li> Encontrarás </li>
        {existCategory && category.referenciaSubcategorias[0]?.slug &&
          listaMenu(
            category.referenciaSubcategorias[0],
            -1,
            category.referenciaSubcategorias[0].link ||
              withPrefix(`/${category.referenciaSubcategorias[0].slug || "#"}`)
          )}
        {existCategory &&
          category.referenciaSubcategorias[0].referenciaSubcategorias &&
          category.referenciaSubcategorias[0].referenciaSubcategorias.map(
            (subcat, k) => {
              return subcat.verEnMenu
                ? listaMenu(
                    subcat,
                    k,
                    subcat.link ||
                      withPrefix(
                        `/${category.referenciaSubcategorias[0].slug || ""}${
                          subcat.slug || ""
                        }`
                      )
                  )
                : null;
            }
          )}
      </ul>
    </div>
  );
};

interface NavAccordionInterface {
  category: any;
  index: number;
  setActiveItem: Function;
  activeItem: number;
  isAnyActive: boolean;
  setIsAnyActive: Function;
}

export default NavAccordion;
